import React from 'react';
import classNames from 'classnames';

import { Taxonomy } from '@uncinc/react-drupal-core';

import Carousel from '../../../../components/Carousel';

const ArticleDossiers = ({ entities, args }) => {
  const CustomDossiersSize = args.size ? args.size : 0;
  return (
    <div className="DossiersRelated">
      <Carousel>
        {args.map((entity, index) => {
          const id = entity.getIn(['entity', 'nid', '0', 'value']);
          const uuid = entity.getIn(['entity', 'uuid', 0, 'value']);
          const langcode = entity.getIn(['entity', 'langcode', 0, 'value']);
          const classes = classNames('DossiersRelated__row');

          return (
            <div key={`${uuid}:${langcode}`} className={classes}>
              <Taxonomy
                id={id}
                key={`${uuid}:${langcode}`}
                entity={entity.getIn(['entity'])}
                viewMode="teaser"
              />
            </div>
          );
        })}
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const classes = classNames('DossiersRelated__row');
          if (index + CustomDossiersSize >= 3) { return null; }
          return (
            <div key={`${uuid}:${langcode}`} className={classes}>
              <Taxonomy
                id={id}
                key={`${uuid}:${langcode}`}
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default ArticleDossiers;
